webpackJsonp([17],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configuration__ = __webpack_require__(59);


//import config from './../../configuration'








var url = __WEBPACK_IMPORTED_MODULE_6__configuration__["a" /* default */].apiHost;

var UserService = function () {
  function UserService() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, UserService);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(UserService, null, [{
    key: 'getLoggedUser',

    //--------------------------local-storage--------------------------//
    value: function getLoggedUser() {
      return JSON.parse(localStorage.getItem('loggedUser'));
    } // getLoggedUser()

  }, {
    key: 'getEntites',
    value: function getEntites() {
      return JSON.parse(localStorage.getItem('entities'));
    }
  }, {
    key: 'getTokenUser',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return UserService.getLoggedUser();

              case 2:
                user = _context.sent;

                if (!(user != null)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return', user.token);

              case 7:
                return _context.abrupt('return', null);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTokenUser() {
        return _ref.apply(this, arguments);
      }

      return getTokenUser;
    }() //getTokenUser()

  }, {
    key: 'setUserInLocalStorage',
    value: function setUserInLocalStorage(user) {
      localStorage.setItem('loggedUser', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user));
      return true;
    } //setUserInLocalStorage

  }, {
    key: 'removeUserFromLocalStorage',
    value: function removeUserFromLocalStorage() {
      localStorage.removeItem("loggedUser");
      return true;
    } //removeUserFromLocalStorage


  }, {
    key: 'getOneComapanyOfUser',
    value: function getOneComapanyOfUser(company) {
      var index = -1;
      var loop = true;
      var entities = new Array();
      var user = UserService.getLoggedUser();
      for (var i = 0; i < user.access.length && loop; i++) {
        //encontra a empresa
        if (user.access[i].company._id == company) {
          index = i;
          loop = false;
        }
      }
      var entitiesAccess = user.access[index].entities;
      for (var _i = 0; _i < entitiesAccess.length; _i++) {
        //devolve acessos
        entities.push(entitiesAccess[_i]);
      }
      return entities;
    }

    //--------------------------AUTH--------------------------//

  }, {
    key: 'authenticate',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(user) {
        var authUser;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url + 'auth', user);

              case 3:
                authUser = _context2.sent;
                return _context2.abrupt('return', authUser.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0.response.data;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function authenticate(_x) {
        return _ref2.apply(this, arguments);
      }

      return authenticate;
    }() // authenticate()

    //--------------------------CRUD--------------------------//

  }, {
    key: 'getAll',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var users;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url + "users");

              case 3:
                users = _context3.sent;
                return _context3.abrupt('return', users.data);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0.response.data;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function getAll() {
        return _ref3.apply(this, arguments);
      }

      return getAll;
    }() // getAll()

  }, {
    key: 'save',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(user) {
        var userSaved;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url + "users", user);

              case 3:
                userSaved = _context4.sent;
                return _context4.abrupt('return', userSaved.data);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0.response.data;

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function save(_x2) {
        return _ref4.apply(this, arguments);
      }

      return save;
    }() // save()

  }, {
    key: 'update',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(user) {
        var userUpdated;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(url + "users", user);

              case 3:
                userUpdated = _context5.sent;
                return _context5.abrupt('return', userUpdated.data);

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5['catch'](0);
                throw _context5.t0.response.data;

              case 10:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 7]]);
      }));

      function update(_x3) {
        return _ref5.apply(this, arguments);
      }

      return update;
    }() // update()

  }, {
    key: 'remove',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(user) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.delete(url + "users", {
                  data: user
                });

              case 3:
                _context6.next = 8;
                break;

              case 5:
                _context6.prev = 5;
                _context6.t0 = _context6['catch'](0);
                throw _context6.t0.response.data;

              case 8:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 5]]);
      }));

      function remove(_x4) {
        return _ref6.apply(this, arguments);
      }

      return remove;
    }() // remove()

  }, {
    key: 'getUserByUsername',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(user) {
        var u;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url + "username", user);

              case 3:
                u = _context7.sent;

                console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(u));
                return _context7.abrupt('return', u.data);

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7['catch'](0);
                throw _context7.t0.response.data;

              case 11:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 8]]);
      }));

      function getUserByUsername(_x5) {
        return _ref7.apply(this, arguments);
      }

      return getUserByUsername;
    }() // getUserByUsername()

  }, {
    key: 'firstAccess',
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8(user) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url + "first_access", user);

              case 3:
                return _context8.abrupt('return', _context8.sent);

              case 6:
                _context8.prev = 6;
                _context8.t0 = _context8['catch'](0);

                console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_context8.t0));
                throw _context8.t0.response.data;

              case 10:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 6]]);
      }));

      function firstAccess(_x6) {
        return _ref8.apply(this, arguments);
      }

      return firstAccess;
    }()
  }]);

  return UserService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (UserService);

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DrawerMenu__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AlertBar__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormLogin__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__service_UserService__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__events__ = __webpack_require__(136);




var _components$data$comp;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = (_components$data$comp = {
   components: {
      DrawerMenu: __WEBPACK_IMPORTED_MODULE_3__components_DrawerMenu__["a" /* default */],
      FormLogin: __WEBPACK_IMPORTED_MODULE_5__components_FormLogin__["a" /* default */],
      AlertBar: __WEBPACK_IMPORTED_MODULE_4__components_AlertBar__["a" /* default */]
   },

   data: function data() {
      return {
         companyName: 'BrilharMS',
         user: {
            access: []
         },
         loggedLocal: false,
         home: '/',
         company: {},
         companies: [],
         drawer: false,
         drawerOpen: false,
         isEditing: null
      };
   },
   computed: {
      loggedUser: function loggedUser() {
         return this.$store.getters.getStateLog;
      },
      isUnauthorized: function isUnauthorized() {
         return this.$route.path == '/unauthorized' ? true : false;
      }
   },

   methods: {
      goToHome: function goToHome() {
         this.$router.push('/');
      },
      changeDrawerMenu: function changeDrawerMenu() {
         if (this.drawerOpen == true) window.getApp.$emit('CLOSE_DRAWER_MENU'), this.drawerOpen = false;else if (this.drawerOpen == false) window.getApp.$emit('OPEN_DRAWER_MENU'), this.drawerOpen = true;
      },
      selectCompany: function selectCompany() {
         this.$refs.drawerMenu.loadAccess(this.company);
         this.containsEntities();
      },
      setCompanies: function setCompanies() {
         if (this.$store.getters.getCompany) {
            this.company = this.$store.getters.getCompany;
         }
         var user = this.$store.getters.getUserLogged;
         this.loggedLocal = true;
         for (var index = 0; index < user.access.length; index++) {
            var element = user.access[index];
            this.companies.push(user.access[index].company);
         }
      },
      containsEntities: function containsEntities() {
         if (this.$store.getters.getStateLog) {
            var entities = this.$store.getters.getEntities;
            var path = this.$route.meta.access;
            if (!entities.includes(path) && this.$route.path != '/') {
               this.$router.push('/unauthorized');
            }
         }
      },
      init: function init() {
         this.companies = [];
         this.company = {};
         this.loggedLocal = false;
      },


      companyText: function companyText(item) {
         return item.socialName + ' - ' + item.fantasyName;
      }
   },
   beforeMount: function beforeMount() {
      if (localStorage.getItem('loggedUser')) {
         this.loggedLocal = true;
      }
   },
   mounted: function mounted() {
      this.$store.dispatch('loadLoggedUser');
      this.setCompanies();
   }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$data$comp, 'beforeMount', function beforeMount() {
   var _this = this;

   return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
         while (1) {
            switch (_context.prev = _context.next) {
               case 0:
                  __WEBPACK_IMPORTED_MODULE_7__events__["a" /* default */].forEach(function (item) {
                     _this.$on(item.name, item.callback);
                  });

               case 1:
               case 'end':
                  return _context.stop();
            }
         }
      }, _callee, _this);
   }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$data$comp, 'created', function created() {
   window.getApp = this;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$data$comp, 'props', {
   source: String
}), _components$data$comp);

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_DrawerItems_Items__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_UserService__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    var _this = this;

    window.getApp.$on('CLOSE_DRAWER_MENU', function () {
      _this.drawer = false;
    });
    window.getApp.$on('OPEN_DRAWER_MENU', function () {
      _this.drawer = true;
    });
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    if (this.$store.getters.getCompany) {
      this.loadAccess(this.$store.getters.getCompany);
    }
  },

  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_1__service_UserService__["a" /* default */].removeUserFromLocalStorage();
      this.$router.push("/");
      this.$store.commit("loggoutUser");
      this.$emit("loggout");
    },
    loadAccess: function loadAccess(company) {
      this.items = __WEBPACK_IMPORTED_MODULE_0__data_DrawerItems_Items__["a" /* default */].getItems(company);
      this.$store.commit('setEntities', company);
    }
  },
  data: function data() {
    return {
      drawer: false,
      items: []
    };
  }
});

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertBar_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b980c7c4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertBar_vue__ = __webpack_require__(131);
function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b980c7c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b980c7c4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    alerts: function alerts() {
      return this.$store.state.alerts ? this.$store.state.alerts : [];
    }
  },
  methods: {
    close: function close(i) {
      this.$store.commit('closeAlert', i);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AlertBar__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_UserService__ = __webpack_require__(6);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AlertBar: __WEBPACK_IMPORTED_MODULE_2__components_AlertBar__["a" /* default */]
  },

  data: function data() {
    return {
      user: {},
      userEdit: {},
      recoveryModel: false,
      dialogConfirmNewKey: false,
      dialogLoading: false,
      dialogSuccessNewKey: false,
      msgLoading: "Validando dados, aguarde...",
      updatePassModel: false,
      confirmPassword: "",
      alert: false,
      msgAlert: []
    };
  },


  methods: {
    login: function login() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__service_UserService__["a" /* default */].authenticate(_this.user);

              case 3:
                user = _context.sent;

                if (!user._id) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3__service_UserService__["a" /* default */].setUserInLocalStorage(user);

              case 7:
                _this.$store.dispatch('loadLoggedUser');
                location.reload(true);

              case 9:
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);

                _this.$store.commit("showAlertError", _context.t0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 11]]);
      }))();
    },
    editPass: function editPass() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.msgAlert = [];

                if (!_this2.user.username) _this2.msgAlert.push("O username deve ser informado");

                if (!_this2.user.key || _this2.user.key == "") _this2.msgAlert.push("A chave provisória deve ser informada");

                if (!_this2.user.password) _this2.msgAlert.push("A senha deve ser informada");

                if (!_this2.confirmPassword) _this2.msgAlert.push("A confirmação de senha deve ser informada");

                if (_this2.user.password && _this2.confirmPassword) {
                  if (_this2.user.password != _this2.confirmPassword) _this2.msgAlert.push("A senha e a confirmação da senha são diferentes");else _this2.msgAlert = [];
                }

                if (_this2.msgAlert.length > 0) {
                  _this2.alert = true;
                } else {
                  _this2.msgAlert = [];
                  _this2.alert = false;
                  _this2.update();
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    update: function update() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var u;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__service_UserService__["a" /* default */].getUserByUsername(_this3.user);

              case 2:
                u = _context3.sent;

                console.log(u);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  },

  watch: {
    dialogLoading: function dialogLoading(val) {
      var _this4 = this;

      if (!val) return;

      setTimeout(function () {
        _this4.msgLoading = "Criando chave, aguarde...";
        setTimeout(function () {
          _this4.msgLoading = "Enviando e-mail, aguarde...";
          setTimeout(function () {
            _this4.dialogLoading = false;
            _this4.dialogConfirmNewKey = false;
            _this4.dialogSuccessNewKey = true;
          }, 2000);
        }, 2000);
      }, 2000);

      this.user = {};
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
   apiHost: 'https://solus-api.lambdatech.com.br/',

   //apiHost: 'http://localhost:3000/',

   decimalPlaces: 2,
});


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_currency_filter__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_currency_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_currency_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_currency_field__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_currency_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_v_currency_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_currency_field_dist_index_css__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_currency_field_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_v_currency_field_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_store_main_js__ = __webpack_require__(148);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_v_currency_field___default.a);

// import money from 'v-money';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_currency_filter___default.a, {
  symbol: 'R$',
  thousandsSeparator: '.',
  fractionCount: 4,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a, {
  theme: {
    primary: '#1976D2',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$eventHub = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  store: __WEBPACK_IMPORTED_MODULE_8__src_store_main_js__["a" /* default */],
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  components: {
    App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
  },
  template: '<App/>'
});

/***/ }),
/* 70 */,
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_226e3ed8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(137);
function injectStyle (ssrContext) {
  __webpack_require__(72)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-226e3ed8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_226e3ed8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawerMenu_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_360cf889_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawerMenu_vue__ = __webpack_require__(128);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawerMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_360cf889_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawerMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_UserService__ = __webpack_require__(6);



var items = [{
   icon: 'home',
   text: 'Início',
   to: '/'
}, {
   icon: 'folder_special',
   text: 'Contratos e Licitação',
   children: []
}, {
   icon: 'folder_shared',
   text: 'Operacional',
   children: []
}, {
   icon: 'shopping_cart',
   text: 'Almoxarifado',
   children: []
}, {
   icon: 'ballot',
   text: 'Cadastros Gerais',
   children: []
}];
var childrens = [{
   code: 1,
   icon: 'list',
   text: 'Orçamento',
   to: '/budget',
   access: 'budget'
}, {
   code: 1,
   icon: 'description',
   text: 'Contrato',
   to: '/contract',
   access: 'contract'
}, {
   code: 2,
   icon: 'list_alt',
   text: 'Requisições',
   to: '/requests',
   access: 'requests'
}, {
   code: 2,
   icon: 'description',
   text: 'Contratos Inicial',
   to: '/initialapproval',
   access: 'initialapproval'
}, {
   code: 3,
   icon: 'assignment',
   text: 'Estoque',
   to: '/stock',
   access: 'stock'
}, {
   code: 4,
   icon: 'person',
   text: 'Cliente',
   to: '/client',
   access: 'client'
}, {
   code: 4,
   icon: 'face',
   text: 'Usuário',
   to: '/user',
   access: 'user'
}, {
   code: 4,
   icon: 'business',
   text: 'Empresa',
   to: '/company',
   access: 'company'
}, {
   code: 4,
   icon: 'location_city',
   text: 'Cidade',
   to: '/city',
   access: 'city'
}, {
   code: 4,
   icon: 'build',
   text: 'Serviço',
   to: '/office',
   access: 'office'
}, {
   code: 4,
   icon: 'gavel',
   text: 'Convenção Coletiva',
   to: '/convention',
   access: 'convention'
}, {
   code: 4,
   icon: 'all_inbox',
   text: 'Categoria de Produto',
   to: '/category',
   access: 'category'
}, {
   code: 4,
   icon: 'move_to_inbox',
   text: 'Produto',
   to: '/product',
   access: 'product'
}];

var DrawerItems = function () {
   function DrawerItems() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DrawerItems);
   }

   __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DrawerItems, null, [{
      key: 'getItems',
      value: function getItems(company) {
         items[1].children = [];
         items[2].children = [];
         items[3].children = [];
         items[4].children = [];
         var userAccess = __WEBPACK_IMPORTED_MODULE_2__service_UserService__["a" /* default */].getOneComapanyOfUser(company);
         for (var index = 0; index < userAccess.length; index++) {
            var element = userAccess[index].entity;
            for (var i = 0; i < childrens.length; i++) {
               if (element == childrens[i].access) {
                  items[childrens[i].code].children.push(childrens[i]);
               }
            }
         }
         return items;
      }
   }]);

   return DrawerItems;
}();

/* harmony default export */ __webpack_exports__["a"] = (DrawerItems);

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"clipped":_vm.$vuetify.breakpoint.lgAndUp,"fixed":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{staticClass:"text-xs-center"},[_c('div',{staticStyle:{"width":"90%","margin":"auto"}},[_c('img',{staticStyle:{"width":"50%"},attrs:{"src":__webpack_require__(129),"alt":"Vuetify"}})])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.items),function(item){return [(item.heading)?_c('v-layout',{key:item.heading,attrs:{"row":"","align-center":""}},[_c('v-flex',{attrs:{"xs6":""}},[(item.heading)?_c('v-subheader',[_vm._v("\n            "+_vm._s(item.heading)+"\n          ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs6":""}},[_c('a',{staticClass:"body-2 black--text",attrs:{"href":"#!"}},[_vm._v("EDIT")])])],1):(item.children)?_c('v-list-group',{key:item.text,attrs:{"prepend-icon":item.icon,"append-icon":"arrow_drop_down"},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-title',[_vm._v("\n            "+_vm._s(item.text)+"\n          ")])],1),_vm._v(" "),_vm._l((item.children),function(child,i){return _c('v-list-tile',{key:i,attrs:{"to":child.to}},[(child.icon)?_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(child.icon))])],1):_vm._e(),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n              "+_vm._s(child.text)+"\n            ")])],1)],1)})],2):_c('v-list-tile',{key:item.text,attrs:{"to":item.to}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n            "+_vm._s(item.text)+"\n          ")])],1)],1)]}),_vm._v(" "),(_vm.items.length==0)?[_c('div',{staticStyle:{"width":"80%","margin":"auto"}},[_c('h1',[_vm._v("Selecine Uma Empresa")])])]:_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),[_c('v-list-tile',{on:{"click":_vm.logout}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("directions_run")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Sair")])],1)],1)]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-brilhar-site.2560136.png";

/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.alerts.length > 0),expression:"alerts.length > 0"}],attrs:{"xs12":""}},_vm._l((_vm.alerts),function(alert,i){return _c('v-alert',{key:i,attrs:{"type":alert.type},model:{value:(alert.show),callback:function ($$v) {_vm.$set(alert, "show", $$v)},expression:"alert.show"}},[_vm._v("\n      "+_vm._s(alert.message)+"\n      "),_c('v-btn',{attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.close(i)}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("close")])],1)],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormLogin_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70e33152_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormLogin_vue__ = __webpack_require__(135);
function injectStyle (ssrContext) {
  __webpack_require__(133)
  __webpack_require__(134)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70e33152"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70e33152_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"font-weight-light",attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('alert-bar'),_vm._v(" "),_c('v-card',{staticClass:"elevation-12 text-xs-center"},[_c('v-card-text',[_c('v-form',[_c('v-text-field',{attrs:{"return-masked-value":"","mask":"###.###.###-##","prepend-icon":"person","name":"login","label":"CPF","type":"text"},model:{value:(_vm.user.identification),callback:function ($$v) {_vm.$set(_vm.user, "identification", $$v)},expression:"user.identification"}}),_vm._v(" "),_c('v-text-field',{attrs:{"id":"password","prepend-icon":"lock","name":"password","label":"Senha","type":"password"},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"elevation-0 font-weight-light",attrs:{"block":"","round":"","large":"","color":"primary"},on:{"click":_vm.login}},[_vm._v("ENTRAR")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('a',{attrs:{"slot":"activator"},on:{"click":function($event){_vm.recoveryModel = true;}},slot:"activator"},[_vm._v("Recuperar senha")]),_vm._v(" "),_c('span',[_vm._v("Gerar uma nova chave de acesso provisória")])])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.recoveryModel),callback:function ($$v) {_vm.recoveryModel=$$v},expression:"recoveryModel"}},[_c('v-card',{staticClass:"recovery"},[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Recuperar Senha")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Nome *"},model:{value:(_vm.user.name),callback:function ($$v) {_vm.$set(_vm.user, "name", $$v)},expression:"user.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"E-mail *"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Username *"},model:{value:(_vm.user.cpf),callback:function ($$v) {_vm.$set(_vm.user, "cpf", $$v)},expression:"user.cpf"}})],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":"","large":""},on:{"click":function($event){_vm.dialogConfirmNewKey = true; _vm.recoveryModel = false;}},slot:"activator"},[_vm._v("\n            Gerar Chave\n            "),_c('v-icon',{staticClass:"ml-3"},[_vm._v("vpn_key")])],1),_vm._v(" "),_c('span',[_vm._v("Gerar chave de acesso provisória")])],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center mt-4"},[_c('span',{staticClass:"blue--text"},[_vm._v("Os campos marcados com o (*) são obrigatórios")]),_c('br'),_c('br')]),_vm._v(" "),_c('v-footer',{staticClass:"pa-3 mb-3",attrs:{"height":"auto","color":"info"}},[_c('span',{staticClass:"white--text"},[_c('strong',[_vm._v("AVISO:")]),_vm._v("\n          após preencher os campos e clickar no botão de Gerar Chave, será criada uma chave de acesso provisória que\n          deve ser usada para acessar o sistema e ser alterada logo em seguida.\n        ")])])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400","persistent":""},model:{value:(_vm.dialogConfirmNewKey),callback:function ($$v) {_vm.dialogConfirmNewKey=$$v},expression:"dialogConfirmNewKey"}},[_c('v-card',{staticClass:"recovery"},[_c('v-card-title',{staticClass:"headline",attrs:{"primary-title":""}},[_vm._v("\n        Confirmar dados\n      ")]),_vm._v(" "),_c('v-card-text',[_c('span',[_c('strong',[_vm._v("Nome:")]),_vm._v(" "+_vm._s(_vm.user.name)+"\n          "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Username:")]),_vm._v(" "+_vm._s(_vm.user.username)+"\n          "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("E-mail:")]),_vm._v(" "+_vm._s(_vm.user.email)+"\n        ")])]),_vm._v(" "),_c('v-card-text',[_c('span',[_c('strong',[_vm._v("Confirma a geração da chave de acesso para os dados acima informados ?")])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',{staticClass:"text-xs-center"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.dialogLoading = true;}}},[_vm._v("\n          Sim\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"error","flat":""},on:{"click":function($event){_vm.dialogConfirmNewKey = false}}},[_vm._v("\n          Não\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"500"},model:{value:(_vm.dialogLoading),callback:function ($$v) {_vm.dialogLoading=$$v},expression:"dialogLoading"}},[_c('v-card',{attrs:{"color":"primary","dark":""}},[_c('v-card-text',[_vm._v("\n        "+_vm._s(_vm.msgLoading)+"\n        "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.dialogSuccessNewKey),callback:function ($$v) {_vm.dialogSuccessNewKey=$$v},expression:"dialogSuccessNewKey"}},[_c('v-card',{staticClass:"recovery font-weight-light"},[_c('p',[_c('span',[_c('strong',[_vm._v("A chave foi gerada com sucesso")])])]),_vm._v(" "),_c('p',[_c('span',[_c('strong',[_vm._v("Por favor acesse o e-mail para visualizar e acessar com o seu Username")])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"primary"},on:{"click":function($event){_vm.dialogSuccessNewKey = false;}}},[_c('v-icon',[_vm._v("thumb_up")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.updatePassModel),callback:function ($$v) {_vm.updatePassModel=$$v},expression:"updatePassModel"}},[_c('v-card',{staticClass:"recovery"},[_c('v-toolbar',{staticClass:"elevation-3",attrs:{"color":"white"}},[_c('v-toolbar-items',[_c('v-btn',{attrs:{"color":"error","icon":"","round":"","flat":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.updatePassModel = false;}}},[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("remove")])],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-title',{staticClass:"headline font-weight-light"},[_vm._v("\n          Criar senha\n        ")])],1),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.alert = false; _vm.msgAlert = '';}}},[_c('v-alert',{attrs:{"dismissible":"","outline":"","type":"error"},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},_vm._l((_vm.msgAlert),function(msg){return _c('span',{key:msg},[_vm._v(_vm._s(msg)+" "),_c('br')])}),0)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{staticClass:"font-weight-light",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Username *","disabled":""},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Chave de acesso provisória *"},model:{value:(_vm.user.key),callback:function ($$v) {_vm.$set(_vm.user, "key", $$v)},expression:"user.key"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Senha *","type":"password"},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Confirmar senha *","type":"password"},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center mt-4"},[_c('span',{staticClass:"blue--text"},[_vm._v("Os campos marcados com o (*) são obrigatórios")]),_c('br'),_c('br')]),_vm._v(" "),_c('v-footer',{staticClass:"pa-3 mb-3",attrs:{"height":"auto","color":"info"}},[_c('span',{staticClass:"white--text"},[_c('strong',[_vm._v("AVISO:")]),_vm._v("\n          após criada, a senha não poderá ser visualizada, sendo necessário gerar uma nova chave de acesso proviśoria\n          e criar uma senha novamente.\n        ")])]),_vm._v(" "),_c('v-card-actions',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"title":"Criar a senha informada para o usuário","color":"info","block":"","round":""},on:{"click":function($event){return _vm.editPass();}}},[_vm._v("Criar\n          senha")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'APP_LOGIN_SUCCESS',
  callback: function callback(e) {
    window.getApp.loggedUser = JSON.parse(localStorage.getItem('loggedUser'));
    this.$router.push({
      path: '/'
    });
  }
}, {
  name: 'APP_LOGOUT',
  callback: function callback(e) {
    localStorage.removeItem('loggedUser');
    window.getApp.loggedUser = null;
    this.$store.dispatch('user/logout');
    this.$router.replace({
      path: '/'
    });
  }
}]);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loggedUser && _vm.loggedLocal)?_c('v-app',{attrs:{"id":"inspire","transition":"slide-x-transition"}},[_c('drawer-menu',{ref:"drawerMenu",on:{"loggout":_vm.init}}),_vm._v(" "),_c('v-toolbar',{staticClass:"elevation-4 white--text font-weight-medium toolbarBorder",attrs:{"clipped-left":_vm.$vuetify.breakpoint.lgAndUp,"color":"primary","dark":"","app":"","fixed":""}},[_c('v-toolbar-side-icon',{staticClass:"white--text font-weight-light",on:{"click":function($event){$event.stopPropagation();return _vm.changeDrawerMenu.apply(null, arguments)}}},[_c('v-icon',[_vm._v("menu")])],1),_vm._v(" "),_c('div',{staticStyle:{"float":"right","width":"7%","margin":"6px"}},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":__webpack_require__(138)}})]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{class:_vm.$vuetify.breakpoint.mdOnly ? 'mt-5' : '',staticStyle:{"width":"40%"}},[_c('v-layout',{attrs:{"row":"","wrap":"","algin-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-overflow-btn',{attrs:{"auto-select-first":"","background-color":"transparent","items":_vm.companies,"label":"Empresa Atual","item-text":_vm.companyText,"item-value":"_id","target":"#dropdown-example","no-data-text":"Nenhuma Empresa Habilitada","hide-selected":""},on:{"change":_vm.selectCompany},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}})],1)],1)],1)],1),_vm._v(" "),(_vm.isUnauthorized)?_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{staticClass:"text-xs-center mt-5",attrs:{"xs12":""}},[_c('img',{staticStyle:{"width":"5%"},attrs:{"src":__webpack_require__(139)}})]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('span',{staticClass:"subtitle"},[_vm._v("Acesso não autorizado")])])],1)],1)],1):_c('v-content',[_c('v-container',{staticStyle:{"background-color":"#F5F5F5"},attrs:{"fluid":""}},[_c('router-view')],1)],1)],1):_c('v-app',[_c('v-content',{staticClass:"bg-image"},[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('form-login',{on:{"userIsLogged":_vm.setCompanies}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-light-horizontal.ed79fc6.png";

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_UserService__ = __webpack_require__(6);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */]

});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    //precisa de autorização?
    var user = __WEBPACK_IMPORTED_MODULE_3__service_UserService__["a" /* default */].getLoggedUser();
    if (user == null) {
      //usuario é nulo?
      next({ path: '/' });
    } else if (to.matched.some(function (record) {
      return record.meta.access;
    })) {
      //requer permissão de acesso?
      var entities = __WEBPACK_IMPORTED_MODULE_3__service_UserService__["a" /* default */].getEntites();
      if (to.matched.some(function (record) {
        return !entities.includes(record.meta.access);
      })) {
        //usuario NÃO tem permissão?
        next({ path: '/unauthorized' });
      } else next();
    } else next();
  } else next();
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 141 */,
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var routes = [{
  path: '/unauthorized',
  name: 'unauthorized'
}, {
  path: '/',
  name: 'Início',
  component: function component() {
    return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 156));
  }
}, {
  path: '/client',
  name: 'Cliente',
  meta: {
    access: 'client',
    requiresAuth: true
  },
  component: function component() {
    return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 157));
  }
}, {
  path: '/office',
  name: 'Servico',
  meta: {
    access: 'office',
    requiresAuth: true
  },
  component: function component() {
    return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 158));
  }
}, {
  path: '/grupo',
  name: 'Grupo',
  meta: {
    access: 'group',
    requiresAuth: true
  },

  component: function component() {
    return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 159));
  }
}, {
  path: '/user',
  name: 'Usuário',
  meta: {
    access: 'user',
    requiresAuth: true
  },

  component: function component() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 160));
  }
}, {
  path: '/company',
  name: 'Empresa',
  meta: {
    access: 'company',
    requiresAuth: true
  },
  component: function component() {
    return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 161));
  }
}, {
  path: '/additional_work',
  name: 'Adicional de Trabalho',
  meta: {
    access: 'additional_work',
    requiresAuth: true
  },
  component: function component() {
    return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 162));
  }
}, {
  path: '/convention',
  name: 'Convenção Coletiva',
  meta: {
    access: 'convention',
    requiresAuth: true
  },
  component: function component() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 163));
  }
}, {
  path: '/budget',
  name: 'Orçamento',
  meta: {
    access: 'budget',
    requiresAuth: true
  },
  component: function component() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 164));
  }
}, {
  path: '/city',
  name: 'Cidade',
  meta: {
    access: 'city',
    requiresAuth: true
  },
  component: function component() {
    return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 165));
  }
}, {
  path: '/category',
  name: 'Categoria de Produtos',
  meta: {
    access: 'category',
    requiresAuth: true
  },
  component: function component() {
    return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 166));
  }
}, {
  path: '/product',
  meta: {
    access: 'product',
    requiresAuth: true
  },
  name: 'Produtos',
  component: function component() {
    return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 167));
  }
}, {
  path: '/contract',
  name: 'Contratos',
  meta: {
    access: 'contract',
    requiresAuth: true
  },
  component: function component() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 168));
  }
}, {
  path: '/requests',
  name: 'Requisições',
  meta: {
    access: 'requests',
    requiresAuth: true
  },
  component: function component() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 169));
  }
}, {
  path: '/initialapproval',
  name: 'Contrato Inicial',
  meta: {
    access: 'initialapproval',
    requiresAuth: true
  },
  component: function component() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 170));
  }
}, {
  path: '/stock',
  name: 'Estoque',
  meta: {
    access: 'stock',
    requiresAuth: true
  },
  component: function component() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 171));
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 143 */,
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_budget_main__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user_main__ = __webpack_require__(153);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    budget: __WEBPACK_IMPORTED_MODULE_2__modules_budget_main__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_3__modules_user_main__["a" /* default */]
  }
}));

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(152);






/* harmony default export */ __webpack_exports__["a"] = ({

  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]

});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  amountOfModuleOne: 0,
  amountOfModuleTwo: 0,
  amountOfModuleTwoOne: 0,
  amountOfModuleTwoTwoPercent: 0,
  amountOfModuleThree: 0,
  amountOfModuleFour: 0,
  amountOfModuleFive: 0,
  amountOfModuleSix: 0,
  amountOfConsumablesByMonth: {},
  amountOfEquipmentsByMonth: {},
  amountOfUniformsByMonth: 0,
  amountOfUtensilsByMonth: {},
  analyticalWorksheet: {},
  budget: {},
  budgetFinalized: false,
  hasChange: false
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use stritc";

/* harmony default export */ __webpack_exports__["a"] = ({
  "SET_AMOUNT_OF_MODULE_ONE": function SET_AMOUNT_OF_MODULE_ONE(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    state.amountOfModuleOne = payload;
  },
  "SET_AMOUNT_OF_MODULE_TWO": function SET_AMOUNT_OF_MODULE_TWO(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    state.amountOfModuleTwo = payload;
  },
  "SET_AMOUNT_OF_MODULE_TWO_ONE": function SET_AMOUNT_OF_MODULE_TWO_ONE(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    state.amountOfModuleTwoOne = payload;
  },
  "SET_AMOUNT_OF_MODULE_TWO_TWO_PERCENT": function SET_AMOUNT_OF_MODULE_TWO_TWO_PERCENT(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    state.amountOfModuleTwoTwoPercent = payload;
  },
  "SET_AMOUNT_OF_MODULE_THREE": function SET_AMOUNT_OF_MODULE_THREE(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    state.amountOfModuleThree = payload;
  },
  "SET_AMOUNT_OF_MODULE_FOUR": function SET_AMOUNT_OF_MODULE_FOUR(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    state.amountOfModuleFour = payload;
  },
  "SET_AMOUNT_OF_MODULE_FIVE": function SET_AMOUNT_OF_MODULE_FIVE(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    state.amountOfModuleFive = payload;
  },
  "SET_AMOUNT_OF_MODULE_SIX": function SET_AMOUNT_OF_MODULE_SIX(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    state.amountOfModuleSix = payload;
  },
  "SET_AMOUNT_OF_CONSUMABLES_BY_MONTH": function SET_AMOUNT_OF_CONSUMABLES_BY_MONTH(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    state.amountOfConsumablesByMonth = payload;
  },
  "SET_AMOUNT_OF_EQUIPMENTS_BY_MONTH": function SET_AMOUNT_OF_EQUIPMENTS_BY_MONTH(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    state.amountOfEquipmentsByMonth = payload;
  },
  "SET_AMOUNT_OF_UNIFORMSANDEPIS_BY_MONTH": function SET_AMOUNT_OF_UNIFORMSANDEPIS_BY_MONTH(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    state.amountOfUniformsByMonth = payload;
  },
  "SET_AMOUNT_OF_UTENSILS_BY_MONTH": function SET_AMOUNT_OF_UTENSILS_BY_MONTH(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    state.amountOfUtensilsByMonth = payload;
  },
  "SET_ANALYTICAL_WORKSHEET": function SET_ANALYTICAL_WORKSHEET(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    state.analyticalWorksheet = payload;
  },
  "SET_BUDGET": function SET_BUDGET(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    state.budget = payload;
  },
  "SET_BUDGET_FINALIZED": function SET_BUDGET_FINALIZED(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    state.budgetFinalized = payload;
  },
  "SET_HAS_CHANGE": function SET_HAS_CHANGE(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    state.hasChange = payload;
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getAmountOfModuleOne: function getAmountOfModuleOne(state) {
    return state.amountOfModuleOne;
  },
  getAmountOfModuleTwo: function getAmountOfModuleTwo(state) {
    return state.amountOfModuleTwo;
  },
  getAmountOfModuleTwoOne: function getAmountOfModuleTwoOne(state) {
    return state.amountOfModuleTwoOne;
  },
  getAmountOfModuleTwoTwoPercent: function getAmountOfModuleTwoTwoPercent(state) {
    return state.amountOfModuleTwoTwoPercent;
  },
  getAmountOfModuleThree: function getAmountOfModuleThree(state) {
    return state.amountOfModuleThree;
  },
  getAmountOfModuleFour: function getAmountOfModuleFour(state) {
    return state.amountOfModuleFour;
  },
  getAmountOfModuleFive: function getAmountOfModuleFive(state) {
    return state.amountOfModuleFive;
  },
  getAmountOfModuleSix: function getAmountOfModuleSix(state) {
    return state.amountOfModuleSix;
  },
  getAmountOfConsumablesByMonth: function getAmountOfConsumablesByMonth(state) {
    return state.amountOfConsumablesByMonth;
  },
  getAmountOfEquipmentsByMonth: function getAmountOfEquipmentsByMonth(state) {
    return state.amountOfEquipmentsByMonth;
  },
  getAmountOfUniformsByMonth: function getAmountOfUniformsByMonth(state) {
    return state.amountOfUniformsByMonth;
  },
  getAmountOfUtensilsByMonth: function getAmountOfUtensilsByMonth(state) {
    return state.amountOfUtensilsByMonth;
  },
  getAnalyticalWorksheet: function getAnalyticalWorksheet(state) {
    return state.analyticalWorksheet;
  },
  getBudget: function getBudget(state) {
    return state.budget;
  },
  getBudgetFinalized: function getBudgetFinalized(state) {
    return state.getBudgetFinalized;
  },
  getHasChange: function getHasChange(state) {
    return state.hasChange;
  }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_UserService__ = __webpack_require__(6);





/* import state from './state';
import actions from './actions';
import mutations from './mutations';
 import getters from "./getters"; */
/* harmony default export */ __webpack_exports__["a"] = ({

  /*   state,
    getters,
    actions,
    mutations */
  state: {
    entities: new Array(),
    atualCompany: '',
    user: {
      id: '',
      logged: null,
      name: '',
      access: new Array(),
      email: '',
      token: ''
    }
  },
  getters: {
    getCompany: function getCompany(state) {
      return state.atualCompany;
    },
    getEntities: function getEntities(state) {
      return state.entities;
    },
    getStateLog: function getStateLog(state) {
      return state.user.logged;
    },
    getUserLogged: function getUserLogged(state) {
      return state.user;
    }
  },
  mutations: {
    setLoggedUser: function setLoggedUser(state, payload) {
      state.user.logged = payload._id ? true : false;
      state.user.name = payload.name;
      state.user.access = payload.access;
      state.user.email = payload.email;
      state.user.token = payload.token;
      state.user.id = payload._id;
    },
    loggoutUser: function loggoutUser(state) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      state.user.logged = null;
      state.user.name = "";
      state.user.access = new Array();
      state.user.email = "";
      state.user.token = "";
      state.user.id = "";
      state.entities = new Array();
      localStorage.removeItem('entities');
      localStorage.removeItem('company');
    },
    setEntities: function setEntities(state, payload) {
      state.entities = new Array();
      state.atualCompany = payload;
      var userAccess = __WEBPACK_IMPORTED_MODULE_2__service_UserService__["a" /* default */].getOneComapanyOfUser(state.atualCompany);
      if (userAccess) {
        for (var index = 0; index < userAccess.length; index++) {
          var element = userAccess[index].entity;
          state.entities.push(element);
        }
      }
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers['x-access-company'] = state.atualCompany;
      localStorage.setItem('entities', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.entities));
      localStorage.setItem('company', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.atualCompany));
    }
  },

  actions: {
    loadLoggedUser: function loadLoggedUser(context) {
      try {
        var loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
        var company = JSON.parse(localStorage.getItem("company"));
        if (loggedUser._id) {
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers['x-access-token'] = loggedUser.token;
          context.commit('setLoggedUser', loggedUser);
          if (company) {
            context.commit("setEntities", company);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

});

/***/ })
],[69]);


// WEBPACK FOOTER //
// static/js/app.78cd59f5d9f709e7ca43.js